// extracted by mini-css-extract-plugin
export default {"h":"style_h__s3qQg","duo":"style_duo__p1zAJ"};